import { render } from "./EditorMessageInt.vue?vue&type=template&id=43f71f62&ts=true"
import script from "./EditorMessageInt.vue?vue&type=script&lang=ts"
export * from "./EditorMessageInt.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__